import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import MFGif from './MF.gif';
import Logo from './Logo1.png';
import './Tutorial.css';

const Tutorial = () => {
    const navigate = useNavigate();
    const [currentMessage, setCurrentMessage] = useState('');
    const [messageIndex, setMessageIndex] = useState(0);
    const typingInterval = useRef(null);

    const messages = useMemo(() => [
        "WWelcome, brave adventurer! You've landed at the perfect moment! We're in dire need of skilled hands to gather SCRAP around these parts...",
        "GGather LUMBER and WOOD CHIPS to fuel the Navigators' vision in shaping the future of MINDFOLK!",
        "SStrive for unmatched accuracy and etch your name on the Global Leaderboards!",
        "YYou Lock then you Chop! Align your Axe perfectly with the tree's groove and hit 'Lock'. Then the Power Meter on the right springs to life. Aim for the mid-point on the meter for maximum power and hit 'Chop'!",
        "WWatch as the Axe swings, unveiling your precision scores and your hard-earned rewards.",
        "RRise through the ranks, amass LUMBER - it's essential for your journey!",
        "NNow, set your sights on Locking and Chopping! Good luck!"
    ], []);

    useEffect(() => {
        const typeMessage = (message) => {
            let i = 0;
            setCurrentMessage('');
            clearInterval(typingInterval.current);
            typingInterval.current = setInterval(() => {
                if (i < message.length) {
                    setCurrentMessage(prev => prev + message.charAt(i));
                    i++;
                } else {
                    clearInterval(typingInterval.current);
                }
            }, 40);
        };

        typeMessage(messages[messageIndex]);

        return () => clearInterval(typingInterval.current);
    }, [messageIndex, messages]);

    const handleContinue = () => {
        if (messageIndex < messages.length - 1) {
            setMessageIndex(messageIndex + 1);
        } else {
            navigate('/game');
        }
    };

    return (
        <div className="tutorial-container">
            <img src={Logo} alt="Logo" style={{ position: 'absolute', top: '2%', left: '50%', transform: 'translateX(-50%)', width: '33%', height: 'auto' }} />
            <div className="tutorial-text">
                <p>{currentMessage}</p>
                <div className="tutorial-buttons">
                    <button onClick={handleContinue} className="continue-tutorial-btn">Continue Tutorial</button>
                    <button onClick={handleContinue} className="skip-tutorial-btn">Skip</button>
                </div>
            </div>
            <img src={MFGif} alt="Animated GIF" className="tutorial-gif" />
        </div>
    );
};

export default Tutorial;
